import React from 'react';
import PropTypes from 'prop-types';
import { Paper as MuiPaper } from '@material-ui/core';
import useStyles from './styles';

const Paper = ({
    children,
    elevation,
    ...rest
}) => {
    const classes = useStyles();
    return (
        <MuiPaper
            classes={classes}
            elevation={elevation}
            {...rest}
        >
            {children}
        </MuiPaper>
    );
};

Paper.propTypes = {
    elevation: PropTypes.number,
};

Paper.defaultProps = {
    elevation: 0,
};

export default Paper;
